import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service5 from "../../assets/images/service/05.jpg";

import ImgProstate from "../../assets/images/service_detail/prostate/01.jpg";
import ImgSymptoms from "../../assets/images/service_detail/prostate/02.jpg";
import ImgLaser from "../../assets/images/service_detail/prostate/03.jpg";
import ImgHolep from "../../assets/images/service_detail/prostate/04.png";

const ProstateData = () => {

const data = {
title:"Prostate Enlargement Treatment",
subtitle:"Advanced laser prostate surgery",

heading:"BPH Treatment",
description:"Prostate enlargement is common in men with age causing urine problems. Advanced laser surgery provides safe and effective treatment.",

image:Service5,

sections:[

{
title:"What is Prostate Enlargement (BPH)?",
content:"Prostate enlargement, also known as Benign Prostatic Hyperplasia (BPH), is a common condition in men as they age. The prostate gland increases in size and presses against the urethra, causing difficulty in passing urine. This condition can lead to frequent urination, weak urine flow and bladder problems. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia provides advanced and effective treatment for prostate enlargement using modern laser technology and minimally invasive procedures.",
image: ImgProstate
},

{
title:"Symptoms of Prostate Enlargement",
content:"Prostate enlargement (BPH) commonly affects men above 50 years of age and gradually causes urinary problems. As the prostate grows, it presses on the urethra and bladder leading to difficulty in passing urine and bladder control issues.",
list:[
"Frequent urination especially at night – Increased urge to pass urine multiple times during sleep.",
"Slow or weak urine flow – Reduced pressure or interrupted urine stream.",
"Difficulty starting urination – Straining or delay in initiating urine flow.",
"Feeling of incomplete bladder emptying – Sensation that bladder is not fully empty.",
"Sudden urge to urinate – Strong and urgent need to pass urine.",
"Urine blockage or retention – In severe cases, inability to pass urine.",
"Burning urination – Irritation or infection due to urine retention."
],
image: ImgSymptoms
},

{
title:"Causes of Prostate Enlargement",
content:"Prostate enlargement usually occurs due to age-related hormonal changes in men. As men grow older, prostate tissue gradually increases in size leading to urinary obstruction. Certain lifestyle and medical factors can increase the risk.",
list:[
"Aging and hormonal imbalance – Most common cause in men above 50 years.",
"Family history – Higher risk if father or relatives have prostate problems.",
"Obesity and sedentary lifestyle – Poor metabolic health increases risk.",
"Diabetes and heart problems – Associated with prostate enlargement."
]
},

{
title:"Diagnosis of Prostate Enlargement",
content:"Accurate diagnosis helps determine prostate size and severity of urinary obstruction. Early evaluation ensures timely treatment and prevents complications like bladder or kidney damage.",
list:[
"Digital Rectal Examination (DRE) – Physical examination to assess prostate size.",
"Ultrasound & prostate scan – Imaging to evaluate prostate enlargement and bladder condition.",
"Urine & blood tests – To rule out infection or other medical issues.",
"PSA Test – Screening test to assess prostate health.",
"Uroflowmetry – Measures urine flow rate and obstruction level.",
"Cystoscopy – Camera examination of urinary passage if required."
]
},

{
title:"HOLEP Laser Prostate Surgery (Advanced Treatment)",
content:"HOLEP (Holmium Laser Enucleation of Prostate) is one of the most advanced and effective treatments for enlarged prostate. A high-power laser is used to remove enlarged prostate tissue blocking urine flow without any external cuts. This modern procedure provides long-term relief and is considered the gold standard treatment for moderate to large prostate enlargement.",
list:[
"No external cuts or stitches",
"Complete removal of enlarged prostate tissue",
"Minimal bleeding and safe for elderly patients",
"Suitable for large prostate size",
"Short hospital stay and quick recovery",
"Permanent relief from urine blockage",
"Very low chance of recurrence"
],
image: ImgHolep
},

{
title:"Treatment Options for Prostate Enlargement",
content:"Treatment depends on severity of symptoms, prostate size and overall health. Early treatment improves quality of life and prevents complications.",
list:[
"Medications – For mild to moderate symptoms.",
"Lifestyle changes – Diet, fluid control and bladder training.",
"Laser prostate surgery – Advanced minimally invasive treatment.",
"TURP surgery – Endoscopic removal of enlarged prostate tissue.",
"Minimally invasive procedures – Modern techniques for faster recovery."
],
image: ImgLaser
},

{
title:"Benefits of Laser Prostate Surgery",
content:"Laser prostate surgery is a safe and effective modern treatment that offers faster recovery and long-term relief from urinary problems.",
list:[
"No major cuts or stitches",
"Less bleeding and pain",
"Short hospital stay",
"Faster recovery and return to normal life",
"Improved urine flow and bladder emptying",
"Permanent relief from urine blockage"
]
},

{
title:"Possible Complications if Untreated",
content:"If prostate enlargement is not treated on time, it can lead to serious urinary and kidney complications affecting overall health.",
list:[
"Complete urine blockage requiring emergency treatment",
"Repeated urinary tract infections",
"Bladder damage due to urine retention",
"Kidney damage from long-term obstruction",
"Blood in urine and severe discomfort"
]
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Prostate Treatment?",
content:"Dr. Sachitanand Chaurasia is an experienced urologist known for advanced prostate treatment and laser surgeries. At BBMH (Brijesh Banger Memorial Hospital), patients receive world-class facilities, modern operation theatre and complete care. The focus is on accurate diagnosis, safe surgery and fast recovery ensuring best results for every patient."
}

],

faq:[
{q:"Is prostate surgery safe?",a:"Yes very safe."},
{q:"Recovery time?",a:"3-5 days."},
{q:"Laser vs normal surgery?",a:"Laser is better & faster."}
]
};


return <TreatmentFullLayout data={data}/>
};

export default ProstateData;
